<template>
	<div class="chat-chat-history">
		<div class="chat-chat-history-title">
			<div class="chat-chat-ht-name">
				<span>{{chatUser.custom_wx_name}}&nbsp;与&nbsp;{{chatUser.fans_wx_name}}的聊天</span>
				<span class="chat-chat-ht-sync" @click="syncRecord">同步</span>
				<span class="chat-chat-ht-sync chat-chat-ht-refresh" @click="refreshRecord">刷新</span>
			</div>
			<div class="chat-chat-ht-close" @click="closeHistory">关闭</div>
		</div>
		<div class="chat-chat-history-box">
			<div class="chat-chat-history-wrap" id="chat-history-list" @scroll="historyScroll">
				<div class="chat-chat-history-more">
					<p v-if="hasMore == 0">没有更多消息了！</p>
					<p class="chat-chat-history-active" v-if="hasMore == 1">数据加载中，请稍后...</p>
				</div>
				<chatting
					userType="CCHistory"
					:chatMsg="chatMsg" 
					:chatUser="chatUser"
					key="chat-chat-history-chatting">
				</chatting>
			</div>
		</div>
	</div>
</template>

<script>
	import {webGetChatRecordListWithId,webGetChatRecordListWithTime} from '../../network/web/chat-record.js'
	import Chatting from '../../components/Chatting.vue'
	import {syncFansRecord} from '../../socket/socketEventSender.js'
	
	export default{
		name:"ChatChatHistory",
		props:{
			fansId:{
				type: Number,
				default: 0
			},
			chatType:{
				type: Number,
				default: 0
			},
			chatUser:{
				type: Object,
				default: function(){
					return {}
				}
			}
		},
		components:{
			Chatting
		},
		data(){
			return {
				hasMore: 1,
				firstId: 0,
				startTime: 0,
				canRefresh: false,
				chatMsg:[]
			}
		},
		methods:{
			// 初始化原始数据
			initData(){
				this.canRefresh = false
				this.chatMsg = []
				this.firstId = 0
				this.startTime = 0
				this.hasMore = 1
			},
			
			// 聊天记录上滑刷新
			historyScroll(event){
				let page = document.getElementById("chat-history-list")
				if(page.scrollTop < 25 && this.canRefresh){
					let o_scroll_h = page.scrollHeight
					this.canRefresh = false
					this.getChatRecord(()=>{
						// dom更新后在执行
						this.$nextTick(()=>{
							let top = page.scrollHeight - o_scroll_h
							if(top > 25){
								page.scrollTop = top
							}							
						})
					})	
				}
			},
			
			// 获取列表记录-普通聊天和群里聊天
			getChatRecord(callBack){
				if(this.fansId === 0){
					return
				}
				let param = {
					id: this.fansId,
					type: this.chatType,
					startTime: this.startTime
				}
				webGetChatRecordListWithTime(param,data=>{
					let len = data.length
					if(len > 0){
						for(let i = 0;i<len;i++){
							// data[i].chatType = this.chatType
							data[i].chatType = 0
							if(this.chatType === 2){
								data[i].is_me = data[i].from_id == this.chatUser.custom_wx_id?1:0
							}
							this.chatMsg.unshift(data[i])
						}
						this.startTime = data[len - 1].send_time
						if(len<20){
							this.canRefresh = false
							this.hasMore = 0
						}else{
							this.canRefresh = true
						}
					}else{
						this.canRefresh = false
						this.hasMore = 0
					}
					callBack()
				})
			},
			
			// 组件初始化或粉丝切换时渲染数据
			drawFirstChat(){
				   this.initData()
				   this.getChatRecord(()=>{
					   // dom更新后在执行
					   this.$nextTick(()=>{
							let box = document.getElementById('chat-history-list')
							if(box !== undefined){
								box.scrollTop = box.scrollHeight - box.clientHeight
							}
					   })
				   })
			},
			// 关闭页面
			closeHistory(){
				this.$emit('chat-history-close')
			},
			
			// 同步粉丝聊天记录
			syncRecord(){
				syncFansRecord(this.chatUser.phone_id,this.chatUser.fans_wx_id,0,0)
				CHAT_LAYER.msg('指令推送成功，稍后刷新页面查看！')
			},
			
			// 刷新聊天记录
			refreshRecord(){
				this.drawFirstChat()
			}
		},
		created() {
			this.drawFirstChat()
		}
	}
</script>

<style>
	.chat-chat-history{
		position: absolute;
		top: 30px;
		left: 20px;
		bottom: 30px;
		right: 20px;
		background-color: #FFFFFF;
		z-index: 11;
	}
	.chat-chat-history-title{
		height: 32px;
		line-height: 32px;
		background-color: #e8e8e8;
		padding: 0 10px;
		display: flex;
		justify-content: space-between;
	}
	.chat-chat-ht-sync{
		margin-left: 10px;
		cursor: pointer;
		user-select: none;
		background-color: #009688;
		padding: 2px 8px;
		color: #FFFFFF;
		border-radius: 2px;
		font-size: 12px;
	}
	.chat-chat-ht-refresh{
		background-color: #007DDB !important;
	}
	.chat-chat-ht-close{
		cursor: pointer;
		padding: 0 10px;
	}
	.chat-chat-history-box{
		position: absolute;
		top: 32px;
		left: 0;
		right: 0;
		bottom: 10px;
		overflow: hidden;
	}
	.chat-chat-history-box .chat-chat-history-wrap{
		position: relative;
		width: 100%;
		height: 100%;
		overflow-x: hidden;
		overflow-y: auto;
	}
	.chat-chat-history-wrap .chat-chat-history-more{
		height: 24px;
		line-height: 24px;
		overflow: hidden;
		text-align: center;
		color: #969696;
		font-size: 12px;
	}
	.chat-chat-history-wrap .chat-chat-history-active{
		color: #299615;
	}
</style>
